import axios from 'axios';
import { ENDPOINTS, EVENTS } from './constants';

class NetworkManager {
  constructor() {
    this.api = axios.create({
      baseURL: ENDPOINTS.CORE?.BASE || '',
      timeout: 10_000,
      headers: { 'Content-Type': 'application/json' }
    });

    this.abortControllers = new Map();
  }

  setup(bus) {
    bus.on(EVENTS.NETWORK.REQUEST, (payload) =>
      this.handleNetworkRequest(bus, payload)
    );

    return {
      cancelRequest: this.cancelRequest.bind(this)
    };
  }

  async handleNetworkRequest(bus, payload) {
    const { id } = payload;

    this.emitRequestStart(bus, payload);

    const controller = new AbortController();
    this.abortControllers.set(id, controller);

    const result = await this.sendRequest({
      payload,
      signal: controller.signal
    });

    this.abortControllers.delete(id);

    bus.emit(EVENTS.NETWORK.RESPONSE, result);
  }

  async sendRequest({ payload, signal }) {
    let { id, url, method = 'GET', data } = payload;

    // If full URL, temporarily override axios baseURL
    const isFullUrl = /^https?:\/\//i.test(url);
    const requestConfig = { url, method, data, signal };
    if (isFullUrl) {
      requestConfig.baseURL = '';
    }

    try {
      console.log(id, url, method, data, signal);
      const response = await this.api(requestConfig);
      console.log(response);
      return { id, data: response.data };
    } catch (error) {
      if (axios.isCancel(error)) {
        return { id, canceled: true };
      }
      return { id, error: error.response?.data ?? error.message };
    }
  }

  cancelRequest(id) {
    const controller = this.abortControllers.get(id);
    if (controller) {
      controller.abort();
      this.abortControllers.delete(id);
    }
  }

  emitRequestStart(bus, payload) {
    const { id, url, method = 'GET', data, poll } = payload;
    bus.emit(EVENTS.NETWORK.REQUEST_START, {
      id,
      url,
      method,
      data,
      poll,
      timestamp: Date.now()
    });
  }
}

const networkManager = new NetworkManager();

export const setupNetwork = networkManager.setup.bind(networkManager);
